import {
  Box,
  Divider,
  Hidden,
  Page,
  PageBlock,
  Stack,
} from 'braid-design-system';

import { FaqAccordion } from 'src/components/FaqAccordion/FaqAccordion';
import Header from 'src/components/Header/Header';
import { SiteWideFooter } from 'src/components/SiteWideFooter';
import { VerifyEmailAlert } from 'src/components/VerifyEmailAlert';

import { faqs } from './components/FaqContent';
import { PackagesContainer } from './components/Packages';

const PAGE_WIDTH = 'large';

const PackagesPage = () => (
  <Page footer={<SiteWideFooter />} footerPosition="belowFold">
    <Header title="Sell your business" />

    <Hidden below="tablet">
      <Divider />
    </Hidden>

    <VerifyEmailAlert width={PAGE_WIDTH} />

    <Box paddingTop="xlarge">
      <PageBlock width={PAGE_WIDTH}>
        <Stack space="xxxlarge">
          <PackagesContainer />

          <FaqAccordion faqs={faqs} />
        </Stack>
      </PageBlock>
    </Box>
  </Page>
);

export default PackagesPage;
